import React from 'react';
import { ArrowRight, Sparkles, Heart, Users } from 'lucide-react';

export const Home = () => {
  return (
    // Menggunakan bg-white sebagai dasar halaman
    <div className="min-h-screen bg-white font-body text-stone-700">
      
      {/* --- Hero Section --- */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background Image & Light Overlay */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://ik.imagekit.io/dandie/sapuyung%20dare/ngaju.png"
            alt="Dayak Heritage"
            className="w-full h-full object-cover"
          />
          {/* Gradient overlay diubah agar memudar ke bg-white */}
          <div className="absolute inset-0 bg-gradient-to-b from-white/80 via-white/90 to-white"></div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
          <div className="animate-fade-in-up">
            <h1 className="text-4xl sm:text-5xl md:text-7xl font-extrabold font-heading tracking-tight text-[var(--army-green)] mb-6">
              Sapuyung Dare
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl font-medium font-heading mb-4 text-[var(--uc-gold)]">
              From Ritual Heritage to Fashion Identity
            </p>
            <p className="text-base md:text-lg max-w-3xl mx-auto mb-8 leading-relaxed">
              Sapuyung Dare is a sacred Dayak ritual hat—worn from birth until death, carrying generations of stories woven in bamboo and kajang. Today, through Marajaki Kreatif, this ancestral object of identity is reborn as fashion, art, and modern cultural expression.
            </p>

            <div className="inline-block mb-12">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold font-heading text-[var(--army-green)]">
                Wear a Story. Carry a Culture.
              </h2>
            </div>

            {/* Tombol */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
              <a
                href="/about"
                className="inline-flex items-center justify-center space-x-2 px-8 py-3 rounded-lg font-semibold text-white bg-[var(--rufous)] transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[var(--rufous)] focus:ring-offset-2"
              >
                <Sparkles className="w-5 h-5" />
                <span>Explore the Heritage</span>
              </a>
              <a
                href="/products"
                className="inline-flex items-center justify-center space-x-2 px-8 py-3 rounded-lg font-semibold text-[var(--army-green)] bg-[var(--arylide-yellow)] transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[var(--arylide-yellow)] focus:ring-offset-2"
              >
                <span>Shop the Collection</span>
                <ArrowRight className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* --- Three Pillars Section (Background Hijau Sage) --- */}
      <section className="py-20 md:py-24 bg-[var(--army-green)]/10"> {/* <-- WARNA BARU DITERAPKAN */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold font-heading tracking-tight text-[var(--army-green)] mb-6">
              Where Ancient Motifs Meet Contemporary Design
            </h2>
            <div className="w-20 h-1 bg-[var(--uc-gold)] mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Kartu pilar tetap putih agar kontras dengan section */}
            <div className="text-center p-8 rounded-2xl bg-white shadow-lg transform transition-all duration-300 hover:scale-[1.02]">
              <div className="w-16 h-16 mx-auto mb-6 rounded-full flex items-center justify-center bg-[var(--caramel)]/50">
                <Heart className="w-8 h-8 text-[var(--uc-gold)]" />
              </div>
              <h3 className="text-xl font-semibold font-heading mb-4 text-[var(--army-green)]">
                Craftsmanship Becomes Identity
              </h3>
              <p className="text-stone-700 leading-relaxed">
                Every piece carries ancestral stories woven through generations, transforming traditional artistry into modern cultural expression.
              </p>
            </div>

            <div className="text-center p-8 rounded-2xl bg-white shadow-lg transform transition-all duration-300 hover:scale-[1.02]">
              <div className="w-16 h-16 mx-auto mb-6 rounded-full flex items-center justify-center bg-[var(--caramel)]/50">
                <Sparkles className="w-8 h-8 text-[var(--uc-gold)]" />
              </div>
              <h3 className="text-xl font-semibold font-heading mb-4 text-[var(--army-green)]">
                Heritage Meets Innovation
              </h3>
              <p className="text-stone-700 leading-relaxed">
                Traditional motifs reimagined for contemporary living—from fashion to lifestyle products that honor the past while embracing the future.
              </p>
            </div>

            <div className="text-center p-8 rounded-2xl bg-white shadow-lg transform transition-all duration-300 hover:scale-[1.02]">
              <div className="w-16 h-16 mx-auto mb-6 rounded-full flex items-center justify-center bg-[var(--caramel)]/50">
                <Users className="w-8 h-8 text-[var(--uc-gold)]" />
              </div>
              <h3 className="text-xl font-semibold font-heading mb-4 text-[var(--army-green)]">
                Support the Last Weavers
              </h3>
              <p className="text-stone-700 leading-relaxed">
                By choosing our products, you help preserve endangered craftsmanship and support the regeneration of young artisans.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* --- CTA Section (Block berwarna solid) --- */}
      <section className="py-20 md:py-24 bg-[var(--caramel)]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold font-heading tracking-tight text-[var(--army-green)] mb-6">
            Discover the Stories Behind Each Creation
          </h2>
          <p className="text-lg text-[var(--army-green)]/90 mb-8 leading-relaxed">
            Learn about the sacred rituals, traditional motifs, and the artisans keeping this heritage alive.
          </p>
          <a
            href="/about"
            className="inline-flex items-center justify-center space-x-2 px-8 py-3 rounded-lg font-semibold text-white bg-[var(--rufous)] transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[var(--rufous)] focus:ring-offset-2"
          >
            <span>Learn More About Our Mission</span>
            <ArrowRight className="w-5 h-5" />
          </a>
        </div>
      </section>
    </div>
  );
};

export default Home;